import React from 'react';
import { Modal, Button } from 'antd';
import s from './s.module.less';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void | Promise<void>;
    confirming?: boolean;
};

const CancelEfaxServiceModal = ({ open, onClose, onConfirm, confirming }: Props) => {
    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            closable={false}
            maskClosable={false}
            width={512}
            centered
            className={s.modalRoot}
        >
            <div className={s.inner}>
                <div className={s.iconWrap}>
                    <svg
                        className={s.icon}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                    >
                        <path
                            d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18A2 2 0 0 0 3.53 21H20.47A2 2 0 0 0 22.18 18L13.71 3.86A2 2 0 0 0 10.29 3.86Z"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
                <div className={s.content}>
                    <div className={s.textBlock}>
                        <div className={s.title}>Cancel eFax service?</div>
                        <ul className={s.bodyList}>
                            <li>You will no longer be able to send or receive faxes.</li>
                            <li>
                                Your fax number may be released and can&apos;t be guaranteed if you
                                re-enable eFax later.
                            </li>
                            <li>Billing will stop at the end of your current billing cycle.</li>
                        </ul>
                        <div className={s.bodyConfirm}>Are you sure you want to continue?</div>
                    </div>
                    <div className={s.actions}>
                        <Button className={s.btnBack} onClick={onClose} disabled={confirming}>
                            Back
                        </Button>
                        <Button
                            type="primary"
                            danger
                            className={s.btnConfirm}
                            loading={confirming}
                            onClick={() => void onConfirm()}
                        >
                            Confirm Cancellation
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default CancelEfaxServiceModal;
